export const hasAnyValuesNull = (obj: { [key: string]: any }) => {
  if (!obj) {
    return true;
  }
  return Object.values(obj).some((value) => value === null);
};

export const isEmpty = (obj: { [key: string]: any }) => Object.keys(obj).length === 0;
